import React from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faUser } from "@fortawesome/pro-solid-svg-icons";

import { DESK_COMMUNICATION_EVENTS } from "../../../../../../util/communication_statuses";
import { getEventName } from "../../util";

import "./index.scss";

const CommunicationEvents = ({ events, comm, t }) => {
  return (
    <div className="desk-comm-events">
      {events.map((event, index) => {
        const senderName = event.type === DESK_COMMUNICATION_EVENTS.CHECKIN_SENT && comm.user ? `${comm.user.first_name || ""} ${comm.user.last_name || ""}`.trim() : "";

        return (
          <div className="desk-comm-event-row" key={event.id || index}>
            <div className="desk-comm-event-line">
              <span className="desk-comm-event-name">{getEventName(event, comm, t)}</span>
              <span className="desk-comm-event-time">
                {moment(event.created_on).format("HH:mm")} - {moment(event.created_on).format("DD-MM-YYYY")}
              </span>
            </div>

            {(senderName || event.customer_name) && (
              <div className="desk-comm-event-meta">
                {senderName && (
                  <span className="desk-comm-event-field">
                    <FontAwesomeIcon icon={faUser} className="i-green" />
                    <span>{senderName}</span>
                  </span>
                )}

                {event.customer_name && (
                  <span className="desk-comm-event-field">
                    <FontAwesomeIcon icon={faPencil} className="i-green" />
                    <span>{event.customer_name}</span>
                  </span>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CommunicationEvents;
